import {isEmptyString, isNullOrUndefined} from '../../validators';

export const calcVerifierDigit = (number) => {
  const reversed = number.split('').reverse();
  let indexer = 2;
  const SP = reversed.reduce((acc, current) => {
    acc += (+current) * indexer;
    indexer = indexer === 7 ? 2 : indexer + 1;
    return acc;
  }, 0);

  const R = Math.abs(SP % 11);

  if (R > 11)
    throw new Error('Verifier Digit Number Calculation fail');

  const verifier = 11 - R;
  return verifier === 10 ? 'K' : verifier === 11 ? 0 : verifier;
};


export const cleanRut = (value) => {
  return value.toString().replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
};

export const checkRut = (rutValue) => {

  if (isNullOrUndefined(rutValue) || isEmptyString(rutValue)) {
    return false;
  }

  if (rutValue.toString().length <= 1) {
    return false;
  }

  // remove all no valid char
  const cleanValue = cleanRut(rutValue);

  const bodyPart = cleanValue.slice(0, -1);
  let checkDigitPart = cleanValue.slice(-1).toUpperCase();

  // wrong bodyPart length
  if (bodyPart.length < 7) {
    return false;
  }

  const checkDigitExpected = calcVerifierDigit(bodyPart);

  if (checkDigitExpected.toString() !== checkDigitPart) {
    return false;
  }

  return {bodyPart, checkDigitPart};
};

export const formatRut = (value) => {
  if (isNullOrUndefined(value) || isEmptyString(value)) return '';

  const rutVal = cleanRut(value);

  if (rutVal.length === 9) {
    const sec1 = rutVal.slice(0, 2),
      sec2 = rutVal.slice(2, 5),
      sec3 = rutVal.slice(5, 8),
      sec4 = rutVal.slice(8, 9)
    ;
    return sec1 + '.' + sec2 + '.' + sec3 + '-' + sec4;
  }

  if (rutVal.length === 8) {
    return rutVal.slice(0, 1) + '.' + rutVal.slice(1, 4) + '.' + rutVal.slice(4, 7) + '-' + rutVal.slice(7, 8);
  }
  return value;
};
